import React, { useEffect } from 'react'
import Container from '@material-ui/core/Container'
import Typography from '@material-ui/core/Typography'
import { makeStyles } from '@material-ui/core/styles'
import grey from '@material-ui/core/colors/grey'
import SelectPill from './SelectPill'
import clsx from 'clsx'
import { useForm } from '../../../providers'
import { useGetJobTypes } from '../../../pages/Booking/hooks/useGetJobTypes'
import { extractResponse } from '../../../utils'

const useStyles = makeStyles((theme) => {
    return {
        selectMultiple: {
            border: `solid 1px ${grey[400]}`,
            backgroundColor: '#F3F4F6',
            borderRadius: '10px',
            padding: '1rem',
            display: 'flex',
            gap: '1rem',
            flexWrap: 'wrap',
        },
        typography: {
            marginTop: theme.spacing(2),
            marginBottom: theme.spacing(2),
            paddingTop: theme.spacing(2),
        },
        subTitle: {
            margin: theme.spacing(1),
        },
    }
})

function SelectMultiple({ title, subTitle }) {
    const classes = useStyles()
    const subTitleStyles = [classes.typography, classes.subTitle]

    const { formState, dispatch, currentJobType, setCurrentJobType } = useForm()
    console.log({ currentJobType })

    const res = useGetJobTypes()

    let tagList = []

    if (!res.isLoading && !res.error) {
        const extractedData = extractResponse(res?.data)

        if (extractedData?.data) {
            const rawTags = extractedData?.data?.filter((jobType) => jobType.jtKey === formState.jobType)[0]?.tags

            if (rawTags) {
                tagList = Object.keys(rawTags)?.map((key) => ({
                    key,
                    value: rawTags[key],
                }))
            }
        }
    }

    useEffect(() => {
        if (formState.jobType !== currentJobType) {
            dispatch({ type: 'RESET_TAGS' })
            setCurrentJobType(formState.jobType)
        }
    }, [formState.jobType, dispatch, currentJobType, setCurrentJobType])

    return (
        <>
            <Typography className={classes.typography} variant="h5" component="p">
                {title}
            </Typography>
            <Container className={classes.selectMultiple}>
                {tagList.length > 0 &&
                    tagList?.map((tag) => <SelectPill key={tag.key} name={tag.value} tagKey={tag.key} />)}
            </Container>
            <Typography className={clsx(...subTitleStyles)} variant="body2" component="p">
                {subTitle}
            </Typography>
        </>
    )
}

export default SelectMultiple
